define('app/sss/injected/transform/sss-injected-transform-factory',["factory!sss-wrap"], function (wrap) {
	"use strict";
	return sssInjectedFormatterFactory;
	function sssInjectedFormatterFactory(original, transforms) {
		var inTransforms = angular.copy((transforms || angular.empty).in);
		var outTransforms = angular.copy((transforms || angular.empty).out);
		wrap(original, 
			["$original", function executeParsersAndFormatters($original) {
				angular.forEach(inTransforms)
			}]);
		
	}
	// Unused parser/formatter stuff
	function flattenInjected(injectedArr) {
		if (!angular.isArray(injectedArr) || !injectedArr.length) {
			return [];
		}
		else if (isInjected(injectedArr)) {
			return [injectedArr];
		}
		else {
			var flattened = [];
			flattened.push(angular.map(injectedArr, flattenInjected));
			return flattened;
		}
	}
	function isInjected(value) {
		if (angular.isFunction(value)) {
			return true;
		}
		else if (angular.isArray(value)) {
			if (!angular.isFunction(value[value.length - 1])) {
				return false;
			}
			for (var i = 0; i < (value.length - 1) ; i++) {
				if (!angular.isString(value[i])) {
					return false;
				}
			}
			return true;
		}
		else {
			return false;
		}
	}
	function getFn(injected) {
		if (angular.isFunction(injected)) {
			return injected;
		}
		else if (angular.isArray(injected) && injected.length) {
			var last = injected[injected.length - 1];
			if (angular.isFunction(last)) {
				return last;
			}
		}
		return null;
	}
	function getExtensionData(diFn) {
		if (angular.isFunction(diFn)) {
			return angular.filter(diFn, function (value, prop) {
				return prop !== "$inject";
			});
		}
		else if (angular.isArray(diFn) && angular.isFunction(diFn[diFn.length - 1])) {
			var extensionData = {};
			for (var prop in diFn) {
				if (Math.floor(Number(prop)).toString() !== prop) {
					continue;
				}
				extensionData[prop] = diFn[prop];
			}
			return angular.extend(extensionData, getExtensionData(diFn[diFn.length - 1]));
		}
	}
});
